module.exports = __webpack_public_path__ + "img/gadgets.1c3a871c.jpg";